import { Calendar } from "lucide-react";

const games = [
  {
    date: "MAR 14",
    weekday: "Sat",
    opponent: "vs. Northside Hawks",
    venue: "Memorial Field · 10:00 AM",
    type: "Home",
  },
  {
    date: "MAR 21",
    weekday: "Sat",
    opponent: "@ Riverside Rebels",
    venue: "Riverside HS · 12:30 PM",
    type: "Away",
  },
  {
    date: "MAR 28",
    weekday: "Sat",
    opponent: "vs. East Valley Wolves",
    venue: "Memorial Field · 9:00 AM",
    type: "Home",
  },
  {
    date: "APR 04",
    weekday: "Sat",
    opponent: "@ Lakeside Lions",
    venue: "Lakeside Park · 11:00 AM",
    type: "Away",
  },
  {
    date: "APR 11",
    weekday: "Sat",
    opponent: "vs. Summit Sharks",
    venue: "Memorial Field · 10:00 AM",
    type: "Home",
  },
];

export default function Schedule() {
  return (
    <section
      id="schedule"
      data-testid="schedule-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-12 md:mb-16 items-end">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#e11d2a] mb-5">
              <span className="inline-block w-8 h-px bg-[#e11d2a]" />
              <span>The Schedule · Spring</span>
            </div>
            <h2 className="font-anton uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight">
              Mark your <br />
              <span className="text-[#e11d2a]">calendar.</span>
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-neutral-400 text-sm md:text-base">
              Five Saturdays. Five chances to bring everything you've got. Come
              loud or stay home.
            </p>
          </div>
        </div>

        <div className="border-t border-neutral-900">
          {games.map((g, i) => (
            <div
              key={i}
              data-testid={`schedule-row-${i}`}
              className="group grid grid-cols-12 gap-4 md:gap-8 items-center py-6 md:py-7 border-b border-neutral-900 hover:bg-white/[0.02] transition-colors px-2 md:px-4"
            >
              <div className="col-span-3 md:col-span-2">
                <div className="font-anton text-2xl md:text-4xl tracking-tight leading-none">
                  {g.date}
                </div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 mt-1">
                  {g.weekday}
                </div>
              </div>

              <div className="col-span-6 md:col-span-6">
                <div className="font-anton text-xl md:text-3xl uppercase tracking-tight">
                  {g.opponent}
                </div>
                <div className="text-xs md:text-sm text-neutral-500 mt-1">
                  {g.venue}
                </div>
              </div>

              <div className="col-span-3 md:col-span-2 flex justify-end md:justify-start">
                <span
                  className={`inline-flex items-center gap-2 px-3 py-1.5 border text-[10px] tracking-[0.25em] uppercase ${
                    g.type === "Home"
                      ? "border-[#e11d2a]/60 text-[#e11d2a] bg-[#e11d2a]/5"
                      : "border-neutral-800 text-neutral-400"
                  }`}
                >
                  <span
                    className={`w-1.5 h-1.5 ${
                      g.type === "Home" ? "bg-[#e11d2a]" : "bg-neutral-500"
                    }`}
                  />
                  {g.type}
                </span>
              </div>

              <div className="hidden md:flex md:col-span-2 justify-end">
                <span className="text-[10px] tracking-[0.3em] uppercase text-neutral-700 group-hover:text-white transition-colors">
                  Add to Cal →
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
